import {z} from "zod"
import {remotelyColorLike} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const sourceType = anyImageOpResult.or(remotelyColorLike)

export type SourceType = z.infer<typeof sourceType>
